import axios from 'axios';
import toast from "react-hot-toast";

const API_URL = process.env.NEXT_PUBLIC_ENV === 'LOCAL' ? 'http://localhost:8000/api/' : process.env.NEXT_PUBLIC_API_URL;

const api = axios.create({
    baseURL: API_URL,
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
    },
});

// Request interceptor
api.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('token');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Response interceptor
api.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 403) {
            const message = error.response?.data?.message;
            if (message?.includes('banned')) {
                toast.error('Your account has been banned. Please contact support.');
                // Optionally redirect or force logout
                window.location.href = '/';
            }
        }
        return Promise.reject(error);
    }
);

export default api;